<template>
    <v-list class="soli-lesson-types">
        <v-list-item v-for="app in appTypes" :key="app.name">
            <SoliBtn
                block
                :text="app.name"
                color="contrast--text"
                outlined
                @click="$emit('input', app)"
                :disabled="app.disabled"
            ></SoliBtn
        ></v-list-item>
    </v-list>
</template>

<script>
import { makeLessonTypeCatalog } from "../../Composables/useLessonTypes";

export default {
    props: {
        event: {
            type: Object,
            default: null,
        },
        bgEventClicked: {
            type: String,
            default: null,
        },
        overrideServices: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        // Set initial reactive `disabled` on each type up
        const appTypes = makeLessonTypeCatalog();
        Object.values(appTypes).forEach((type) => (type.disabled = false));
        return {
            appTypes,
        };
    },
    methods: {
        setTeacherAppTypes(arg) {
            if (!arg) return;
            Object.values(this.appTypes).forEach((type) => {
                this.appTypes.weeklyLesson.disabled =
                    !arg?.assignment?.recurrence;
                if (!arg?.assignment) return;
                type.disabled =
                    !arg.assignment.availability.lesson_types.includes(
                        type.name
                    );
            });
        },
        setAppTypesByPermissions(arg) {
            this.appTypes.assessment.disabled = !this.can(
                "Book student assessments"
            );

            let bookingSelf =
                this.$page.props.auth.user.id == arg?.assignment?.user_id ||
                !arg?.assignment;
            let canBookOthers = this.can("Manage location schedule");
            let recurringAssignment = arg?.assignment?.recurrence;

            this.appTypes.weeklyLesson.disabled =
                (!arg?.assignment && !!arg) ||
                (!bookingSelf && !canBookOthers) ||
                recurringAssignment == false ||
                this.bgEventClicked == "Weekly Lesson";
            this.appTypes.dropIn.disabled =
                arg?.assignment && !bookingSelf && !canBookOthers;
            this.appTypes.hold.disabled =
                !bookingSelf &&
                !canBookOthers &&
                !this.can("Manage location room holds");
            this.appTypes.event.disabled =
                arg?.assignment && !bookingSelf && !canBookOthers;
            this.appTypes.reschedule.disabled =
                arg?.assignment && !bookingSelf && !canBookOthers;
        },
    },
    mounted() {
        //if (!this.event) return;
        this.setTeacherAppTypes(this.event);
        if (!this.can("Book student assessments")) {
            this.setAppTypesByPermissions(this.event);
        }
    },
    watch: {
        overrideServices(val) {
            if (val) {
                this.setAppTypesByPermissions(this.event);
            } else {
                this.setTeacherAppTypes(this.event);
            }
        },
    },
};
</script>
